export const mediaImageDataSet = { cy: 'media-image' };

export const moreButtonDataSet = { cy: 'more-button' };

export const answerTextDataSet = { cy: 'answer-text' };

export const moreAnswerTextDataSet = { cy: 'more-answer-text' };
